import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Aos from 'aos';
import 'aos/dist/aos.css';
import Departments from '../Departments';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { toast } from 'react-toastify';
import shape from "../assets/Images/shapes/Thred 05-01.png"
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
export default function ContactForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    department: '',
    appointMentdate: "",
    mode: '',
    message: '',
    pageUrl: window.location.href,
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState(''); // State for success message
  const [errorMessage, setErrorMessage] = useState(''); // State for error message
  const [loading, setLoading] = useState(false)
  const allDepartments = [
    ...Departments.medical.map((dept) => dept.title),
    ...Departments.surgical.map((dept) => dept.title),
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      const numericValue = value.replace(/[^0-9]/g, '').slice(0, 10);
      setFormData({ ...formData, [name]: numericValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  const handleDepartmentChange = (event, newValue) => {
    setFormData({ ...formData, department: newValue || '' });
    if (errors.department && newValue) {
      setErrors({ ...errors, department: '' });
    }
  };

  const validateForm = () => {
    let tempErrors = {};
    if (!formData.name.trim()) {
      tempErrors.name = 'Full name is required';
    } else if (formData.name.length < 2) {
      tempErrors.name = 'Full name must be at least 2 characters';
      setLoading(false)
    }
    if (!formData.email.trim()) {
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = 'Email address is invalid';
    }
    if (!formData.phone) {
      tempErrors.phone = 'Phone number is required';
    } else if (!/^\d{10}$/.test(formData.phone)) {
      tempErrors.phone = 'Phone number must be exactly 10 digits';
    }
    if (!formData.department.trim()) {
      tempErrors.department = 'Department is required';
    }
    if (!formData.message.trim()) {
      tempErrors.message = 'Message is required';
    } else if (formData.message.length < 10) {
      tempErrors.message = 'Message must be at least 10 characters';
      setLoading(false)
    }
    if (!formData.appointMentdate) {
      tempErrors.appointMentdate = 'Please select a date.'
    }
    if (!formData.mode) {
      tempErrors.mode = 'Please select a mode.'
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    console.log(formData)
    e.preventDefault();

    // Clear previous messages
    setSuccessMessage('');
    setErrorMessage('');

    if (validateForm()) {
      setLoading(true)
      try {
        const payload = {
          Subject: 'Lead From MagnAid Website',
          Data: {
            ...formData
          },
        };
        const response = await axios.post(
          'https://maxaidapi.azurewebsites.net/api/EmailApi',
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
            },
            params: {
              code: 'ejJkX3l8qSvgulht0AFLPDySiepq0di50UeRGPa4r5VBAzFudFpISA==',
            },
          }
        );
        const dataMessage = response.data;
        if (dataMessage.status === 'Success') {
          setFormData({
            name: '',
            email: '',
            phone: '',
            department: '',
            message: '',
            appointMentdate:"",
            pageUrl: window.location.href,
          });

          navigate('/thank-you'); // Navigate after a short delay to show success message
        } else {
          // setErrorMessage('Error: ' + response.data.message);
          toast.error('Error: ' + dataMessage.message)

        }
      } catch (error) {
        console.error('Failed to send email:', error.response?.data || error.message);
        toast.error(
          'Failed to send email',
          error.response?.data || error.message,
          { style: { color: 'black' } }
        );
      }
      finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div className="flex justify-center w-full h-auto mt-20 overflow-x-hidden">
      <div className="w-full relative flex justify-end">
        <div className="w-[95%] lg:w-[92%] xl:w-[90%] 2xl:w-4/5 flex justify-center items-center flex-col-reverse lg:flex-row rounded-l-3xl inset-y-0 bg-verylightGreen py-20">
          <div className="w-full lg:w-[55%] xl:w-1/2 2xl:w-[45%]">
            <div className="absolute shape 2xl:left-0 bottom-1">
              <img
                alt="cross-line"
                src={shape}
              />
            </div>
            <div
              data-aos="fade-up"
              className="flex flex-col w-[95%] left-2.5 md:left-4 lg:-left-14 xl:-left-20 relative p-[50px_52px_50px_44px] justify-center rounded-[24px] bg-lightOrange"
            >
              <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Success/Error Messages */}
                {successMessage && (
                  <div className="md:col-span-2">
                    <p className="text-green-600 text-sm mb-4">{successMessage}</p>
                  </div>
                )}
                {errorMessage && (
                  <div className="md:col-span-2">
                    <p className="text-red-500 text-sm mb-4">{errorMessage}</p>
                  </div>
                )}

                <div>
                  <label className="block text-thickGreen text-[18px] mb-[16px] font-body leading-[1.112em] font-bold">
                    Full name
                  </label>
                  <input
                    type="text"
                    name="name" disabled={loading}
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your name"
                    required
                    className="input w-full border border-[#c4d6d6] outline-none bg-white shadow-none rounded-[4px] min-h-[68px] mb-0 p-[16px_24px] text-[18px] leading-[1.111em] placeholder-[#c4d6d6] transition-all focus:border-thickGreen focus:text-thickGreen focus:outline-none hover:border-thickGreen hover:shadow-none"
                  />
                  {errors.name && <p className="text-red-500 text-sm mt-2">{errors.name}</p>}
                </div>
                <div>
                  <label className="block text-thickGreen text-[18px] mb-[16px] font-body leading-[1.112em] font-bold">
                    Phone number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange} disabled={loading}
                    placeholder="Enter your phone number"
                    required
                    className="input w-full border border-[#c4d6d6] bg-white shadow-none rounded-[4
                    px] min-h-[68px] mb-0 p-[16px_24px] outline-none text-[18px] leading-[1.111em] placeholder-[#c4d6d6] transition-all focus:border-thickGreen focus:text-thickGreen focus:outline-none hover:border-thickGreen hover:shadow-none"
                  />
                  {errors.phone && <p className="text-red-500 text-sm mt-2">{errors.phone}</p>}
                </div>

                <div>
                  <label className="block text-thickGreen text-[18px] mb-[16px] font-body leading-[1.112em] font-bold">
                    Email address
                  </label>
                  <input
                    type="email"
                    name="email" disabled={loading}
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"

                    className="input w-full border border-[#c4d6d6] bg-white shadow-none rounded-[4px] min-h-[68px] outline-none mb-0 p-[16px_24px] text-[18px] leading-[1.111em] placeholder-[#c4d6d6] transition-all focus:border-thickGreen focus:text-thickGreen focus:outline-none hover:border-thickGreen hover:shadow-none"
                  />
                  {errors.email && <p className="text-red-500 text-sm mt-2">{errors.email}</p>}
                </div>
                <div>
                  <label className="block text-thickGreen text-[18px] mb-[16px] font-body leading-[1.112em] font-bold">
                    Select Department
                  </label>
                  <Autocomplete
                    options={allDepartments}
                    value={formData.department || null} disabled={loading}
                    onChange={handleDepartmentChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Department"
                        required
                        variant="outlined"
                        error={!!errors.department}
                        helperText={errors.department}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '4px',
                            minHeight: '68px',
                            padding: '14px 24px !important',
                            backgroundColor: '#fff',
                            '& fieldset': {
                              borderColor: '#c4d6d6', border: "1px solid #c4d6d6 !important",
                              outline: "1px !important"
                            },
                            '&:hover fieldset': {
                              borderColor: '#thickGreen',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#thickGreen',
                            },
                          },
                          '& .MuiInputBase-input': {
                            fontSize: '18px',
                            lineHeight: '1.111em',
                            color: formData.department ? '#thickGreen' : '#c4d6d6',
                          },
                        }}
                      />
                    )}
                  />
                </div>
                <div>
                  <label className="block text-thickGreen text-[18px] mb-[16px] font-body leading-[1.112em] font-bold">
                    Select Date
                  </label>
                  <input
                    type="date"
                    name="appointMentdate" disabled={loading}
                    value={formData.appointMentdate}
                    onChange={handleChange}
                    placeholder="Select Date"
                    style={{
                      color: formData.appointMentdate ? '#0d7878' : '#c4d6d6', // set text color conditionally
                    }}
                    className="input w-full border border-[#c4d6d6] bg-white shadow-none rounded-[4px] min-h-[68px] outline-none mb-0 p-[16px_24px] text-[18px] leading-[1.111em] placeholder-[#c4d6d6] transition-all focus:border-thickGreen focus:text-thickGreen focus:outline-none hover:border-thickGreen hover:shadow-none"
                  />
                    {errors.appointMentdate && (
                      <p className="text-red-600">
                        {errors.appointMentdate}
                      </p>
                    )}
                </div>
                <div className='' style={{
                  display: "flex", justifyContent: "center", alignItems: "center"
                }}>
                  <FormControl error={!!errors.mode}>
                    <label className="block text-thickGreen text-[18px] mb-[16px] font-body leading-[1.112em] font-bold" id="demo-row-radio-buttons-group-label">Mode</label>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="mode"
                      value={formData.mode}
                      onChange={handleChange}
                    >
                      <FormControlLabel value="online" control={<Radio />} label="Online" />
                      <FormControlLabel value="in-person" control={<Radio />} label="In-Person" />
                    </RadioGroup>
                    {errors.mode && (
                      <p className='MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-21bjyy-MuiFormHelperText-root'>
                        {errors.mode}
                      </p>
                    )}
                  </FormControl>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-thickGreen text-[18px] mb-[16px] font-body leading-[1.112em] font-bold">
                    Message
                  </label>
                  <textarea
                    name="message" disabled={loading}
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="If you have any specific questions or need any information, please feel free to write it here..."
                    required
                    className="text-area w-full border border-[#c4d6d6] bg-white shadow-none outline-none rounded-[4px] min-h-[172px] mb-0 p-[16px_24px] text-[18px] leading-[1.111em] placeholder-[#c4d6d6] transition-all focus:border-thickGreen focus:text-thickGreen focus:outline-none hover:border-thickGreen hover:shadow-none"
                  ></textarea>
                  {errors.message && <p className="text-red-500 text-sm mt-2">{errors.message}</p>}
                </div>
                <div className="md:col-span-2 flex justify-start">
                  <button
                    type="submit" disabled={loading}
                    className="bg-orange text-white px-7 py-6 rounded-full font-medium  font-body text-[20px] leading-[1.112em] transition-all duration-300 hover:bg-lightGreen hover:bg-opacity-90 hover:translate-y-[-3px] block md:inline-block text-center mr-[0] md:mr-[24px] mt-8 lg:mt-0"
                  >
                    {
                      loading ? 'Sending' : 'Send Message'
                    }
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
            data-aos="fade-up"
            className="w-4/5 lg:w-[45%] xl:w-1/2 2xl:w-[55%] pt-10 lg:pt-0"
          >
            <div className="relative -left-5 xl:left-0 w-full xl:w-4/5 2xl:w-3/5">
              <h1 className="text-[36px] lg:text-[74px] font-heading  text-thickGreen leading-[1.189em] mb-[16px]">
                Get in touch with us today
              </h1>
              <p className="text-paraGreen font-body font-medium text-[18px] leading-[1.667em] mb-[24px]">
                Get exceptional care along with personalised treatment for a healthier future at MagnAid Hospitals by scheduling an appointment.
              </p>
              <div className="mt-4 flex flex-col">
                <p className="text-[18px] text-lightGreen font-body font-medium mb-[12px]">
                  Email address
                </p>
                <Link
                  to="mailto:info@magnaid.com"
                  className="text-[22px] text-thickGreen font-body font-medium"
                >
                  info@magnaid.com
                </Link>
                <Link
                  to="mailto:magnaidhospitals@gmail.com"
                  className="text-[22px] text-thickGreen font-body font-medium"
                >
                  magnaidhospitals@gmail.com
                </Link>
              </div>
              <div className="my-[24px] border-b border-[#c4d6d6]"></div>
              <div className="mb-10 lg:mb-0 mt-4 flex flex-col">
                <p className="text-[18px] text-lightGreen font-body font-medium mb-[12px]">
                  Phone number
                </p>
                <a
                  href="tel:7993999040"
                  className="text-[22px] text-thickGreen font-body font-medium"
                >
                  7993 999 040
                </a>
                <a
                  href="tel:7993999044"
                  className="text-[22px] text-thickGreen font-body font-medium"
                >
                  7993 999 044
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}